document.addEventListener("variant:changed",function(e){let t=e.detail.variant;e.target;var i=document.querySelector(".image-with-text__image--"+t.id),r=document.querySelector(".dimension_details--"+t.id),n=document.querySelector(".carton_dimensions--"+t.id);if(i){var d=i.closest(".image-with-text__image-wrapper").querySelectorAll("img");if(d){for(var o=d.length-1;o>=0;o--)d[o].setAttribute("hidden","");i.removeAttribute("hidden")}}if(r){var a=r.closest(".image-with-text__content-wrapper").querySelectorAll(".dimension_details");if(a){for(o=a.length-1;o>=0;o--)a[o].setAttribute("hidden","");r.removeAttribute("hidden")}}if(n){var l=n.closest(".image-with-text__content-wrapper").querySelectorAll(".carton_dimensions");if(l){for(o=l.length-1;o>=0;o--)l[o].setAttribute("hidden","");n.removeAttribute("hidden")}}});
function updateFlexDirection() {
  const blocks = document.querySelectorAll('.promotion-block-list');
  if (blocks.length >= 2) {
    if (window.innerWidth < 741) {
      blocks[1].style.flexDirection = 'column-reverse';
    } else {
      blocks[1].style.flexDirection = 'row';
    }
  }
}

window.addEventListener('DOMContentLoaded', updateFlexDirection);

// Update on window resize
window.addEventListener('resize', updateFlexDirection);
/////////////////////////////////////////////////////////



